import React from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'
import {Navigation, Pagination} from 'swiper'
import 'swiper/css/pagination'
// import './sixeCss.css'
import { sixSteps } from '../../../../routes/sixSteps'

import styles from './styles.module.scss'
import parse from "html-react-parser";

const SixSteps = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_block}>
        <div className={styles.left}>
          <p className={styles.title}>Шесть шагов — и вы в команде</p>
        </div>
        <div className={styles.right}>
          <p className={styles.title}>
            Как попасть в Generium?
          </p>
          <div className={styles.slider_block}>
            <div className="slider_main_mod_fs">
              <Swiper
                spaceBetween={10}
                initialSlide={0}
                slidesPerView={1}
                slideToClickedSlide
                navigation
                modules={[Navigation]}
              >
                {sixSteps.map(item => (
                  <SwiperSlide key={item.id}>
                    <div className='wrapper-block'>
                      <div className='wrapper-block-left'>
                        <div className='wrapper-block-left-img'>
                          <p className='wrapper-block-left-img-p'></p>
                          <p className='wrapper-block-left-img-id'>{item.id}</p>
                        </div>
                        <p className='wrapper-block-title' style={{ maxWidth: '80%' }}>
                          {<>{parse(item.title)}</>}
                        </p>
                      </div>
                      <p className='wrapper-block-text'>
                        <span>{item.text}</span>
                      </p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SixSteps
